import { Star } from "lucide-react";
import axios from "axios";
import { React, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { format } from "timeago.js";
import { resetCurrentVideo } from "../redux/videoSlice";
import UserAvatar from "./UserAvatar";
const formatDuration = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${m}:${String(s).padStart(2, "0")}`;
};
const Container = styled.div`
  width: ${(props) => (props.type === "sm" ? "auto" : "100%")};
  cursor: pointer;
  display: ${(props) => props.type === "sm" && "flex"};
  gap: 8px;
`;
const ThumbnailContainer = styled.div`
  width: ${(props) => (props.type === "sm" ? "168px" : "100%")};
  height: ${(props) => props.type === "sm" && "94px"};
  aspect-ratio: ${(props) => props.type !== "sm" && "16 / 9"};
  flex-shrink: 0;
  position: relative;
`;
const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colorPrimary};
  border-radius: 14px;
  display: block;
  z-index: 0;
`;
const ThumbnailOverlay = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  font-size: 10px;
  margin: 12px;
  position: absolute;
  right: 0px;
  bottom: 0px;
`;
const TimeStatus = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 4px;
  padding: 3px 4px 3px 4px;
  font-weight: 500;
`;
const Details = styled.div`
  display: flex;
  margin-top: ${(props) => props.type !== "sm" && "8px"};
  gap: 12px;
  flex: 1 1;
`;
const Texts = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;
  flex: 1 1;
`;
const Headline = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: row;
  align-items: flex-start;
`;
const Title = styled.h3`
  font-size: ${(props) => (props.type === "sm" ? "14px" : "16px")};
  font-weight: 600;
  color: ${({ theme }) => theme.colorOnBackground};
  margin: 0px;
  flex: 1 1;
`;
const Ratings = styled.div`
  font-size: 14px;
  display: ${(props) => (props.type === "sm" ? "none" : "flex")};
  gap: 4px;
  flex-direction: row;
  color: ${({ theme }) => theme.colorOnBackground};
  align-items: center;
`;
const ChannelName = styled.h4`
  font-size: 14px;
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
  margin: 0px;
  font-weight: 400;
`;
const Info = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
  margin: 0px;
`;
const RecipeCard = ({ type, video }) => {
  const dispatch = useDispatch();
  const [channel, setChannel] = useState(video.channel ?? null);
  useEffect(() => {
    if (video.channel) {
      setChannel(video.channel);
      return;
    }
    const fetchChannel = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/users/find/${video.userId}`,
      );
      setChannel(res.data);
    };
    fetchChannel();
  }, [video.userId, video.channel]);

  const handleResetCurrentVideo = () => {
    dispatch(resetCurrentVideo());
  };

  return (
    <Link
      to={`/recipe/${video._id}`}
      style={{ textDecoration: "none" }}
      onClick={handleResetCurrentVideo}
    >
      <Container type={type}>
        <ThumbnailContainer type={type}>
          <Thumbnail type={type} src={video.imgURL} />
          <ThumbnailOverlay>
            {video.videoDuration > 0 && (
              <TimeStatus>{formatDuration(video.videoDuration)}</TimeStatus>
            )}
          </ThumbnailOverlay>
        </ThumbnailContainer>
        <Details type={type}>
          <UserAvatar src={(video.channel ?? channel)?.img} name={(video.channel ?? channel)?.name} contrastColor={(video.channel ?? channel)?.contrastColor} size={36} />
          <Texts>
            <Headline>
              <Title type={type}>{video.title}</Title>
              {video.rating && (
                <Ratings>
                  <Star size={14} strokeWidth={0} fill="currentColor" />
                  {video.rating}
                </Ratings>
              )}
            </Headline>
            <ChannelName>{(video.channel ?? channel)?.name}</ChannelName>
            <Info>
              {video.viewCount ?? 0} views • {format(video.createdAt)}
            </Info>
          </Texts>
        </Details>
      </Container>
    </Link>
  );
};
export default RecipeCard;
